import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import {
  Modal,
  InnerWrapper,
  Heading,
  Content,
  StartButton,
  RevisitButton,
} from './elements';
import { useText } from 'common/hooks';
import { ICON } from 'resources/constants';

const deps = {
  userName: state.appContainer.profiles[state.appContainer.user.uid].firstName,
  closeModalClicked: sequences`appContainer.closeModalClicked`,
  beginTutorial: sequences`challenge.tutorial.beginTutorial`,
};

export function OutroModal({
  userName,
  closeModalClicked,
  beginTutorial,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Modal onHide={() => closeModalClicked()} show>
      <InnerWrapper>
        <Heading>
          {t('challenge.GMod10.heading', { userName: userName })}
        </Heading>
        <Content>{t('challenge.GMod10.content')}</Content>
        <StartButton onClick={() => closeModalClicked()}>
          {t('challenge.GMod10.start_button')}
        </StartButton>
        <RevisitButton
          onClick={() =>
            beginTutorial({
              offset: 460,
              activityKey: 'activity_consumption_01',
            })
          }
          icon={ICON.keyboardArrowLeft}
        >
          {t('challenge.GMod10.revisit_button')}
        </RevisitButton>
      </InnerWrapper>
    </Modal>
  );
}

export default connect(deps, OutroModal);
